import { render, staticRenderFns } from "./serviceType.vue?vue&type=template&id=37490236"
import script from "./serviceType.vue?vue&type=script&lang=js"
export * from "./serviceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports